import { render, staticRenderFns } from "./ProfileBalance.vue?vue&type=template&id=493b13e9&scoped=true"
import script from "./ProfileBalance.vue?vue&type=script&lang=js"
export * from "./ProfileBalance.vue?vue&type=script&lang=js"
import style0 from "./ProfileBalance.vue?vue&type=style&index=0&id=493b13e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493b13e9",
  null
  
)

export default component.exports